export default __webpack_public_path__ + "static/media/170.40803c9f.png";